import i18n from './../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../core/components/input-widget/BaseModel";
import _ from 'lodash';
import {SYSTEM_DATE_FORMAT} from "@/core/services/formatter.service";
import moment from 'moment';

export default class SettlementSearch extends BaseModel {
  customer_uuid = null;
  settlement_no = null;
  status = [];
  type = null;
  sale_no = null;
  first_name = null;
  last_name = null;
  company_name = null;
  receipt_no = null;
  settlement_notification_sent = null;
  shipping_tracking_code = null;
  dateRange = {startDate: null, endDate: null};
  salesDateRange = {startDate: null, endDate: null};
  paymentsDateRange = {startDate: null, endDate: null};
  export_id_min = null;
  export_id_max = null;
  is_not_exported = null;
  is_previously_exported = null;
  is_payments_not_exported = null;
  is_payments_previously_exported = null;
  identity_verification = null;
  kyc_status_verification = null;
  vendor_payment_method = null;
  vendor_group_account = null;
  branch_uuids = [];
  client_tier = null;

  rules = {};

  attributeLabels = {
    customer_uuid: i18n.t('Customer'),
    status: i18n.t('Status'),
    settlement_no: i18n.t('No'),
    type: i18n.t('Type'),
    receipt_no: i18n.t('Receipt No'),
    lot_no: i18n.t('Lot No'),
    sale_no: i18n.t('Sale'),
    first_name: i18n.t('First Name'),
    last_name: i18n.t('Last Name'),
    company_name: i18n.t('Company Name'),
    settlement_notification_sent: i18n.t('Settlement Notification Sent'),
    shipping_tracking_code: i18n.t('Tracking Code'),
    export_id_min: i18n.t('From Export ID'),
    export_id_max: i18n.t('To Export ID'),
    is_not_exported: i18n.t('Not Exported'),
    is_previously_exported: i18n.t('Previously exported'),
    is_payments_not_exported: i18n.t("Payments not exported"),
    is_payments_previously_exported: i18n.t("Payments previously exported"),
    identity_verification: i18n.t('Identity Verification'),
    kyc_status_verification: i18n.t('Account/KYC Verification'),
    vendor_payment_method: i18n.t('Vendor Payment Method'),
    vendor_group_account: i18n.t('Vendor Group Account'),
    branch_uuids: i18n.t('Branch'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();
    delete data.customer;

    if (!data.settlement_notification_sent) {
      delete data.settlement_notification_sent;
    }

    if (!this.export_id_min) {
      delete data.export_id_min;
    }

    if (!this.export_id_max) {
      delete data.export_id_max;
    }

    if (!this.is_not_exported) {
      delete data.is_not_exported;
    }

    if (!this.is_previously_exported) {
      delete data.is_previously_exported;
    }

    if (!this.is_payments_not_exported) {
      delete data.is_payments_not_exported;
    }

    if (!this.is_payments_previously_exported) {
      delete data.is_payments_previously_exported;
    }

    if(!this.is_previously_exported && !this.is_payments_previously_exported) {
      delete data.export_id_min;
      delete data.export_id_max;
    }

    if (this.dateRange.startDate) {
      data.date_after = moment(this.dateRange.startDate).format(SYSTEM_DATE_FORMAT);
      data.date_before = moment(this.dateRange.endDate).format(SYSTEM_DATE_FORMAT);
    }

    if (this.salesDateRange.startDate) {
      data.sales_date_after = moment(this.salesDateRange.startDate).format(SYSTEM_DATE_FORMAT);
      data.sales_date_before = moment(this.salesDateRange.endDate).format(SYSTEM_DATE_FORMAT);
    }

    if (this.paymentsDateRange.startDate) {
      data.payments_date_after = moment(this.paymentsDateRange.startDate).format(SYSTEM_DATE_FORMAT);
      data.payments_date_before = moment(this.paymentsDateRange.endDate).format(SYSTEM_DATE_FORMAT);
    }

    if (!this.identity_verification) {
      delete data.identity_verification;
    }

    if (!this.kyc_status_verification) {
      delete data.kyc_status_verification;
    }

    if (!this.approved) {
      delete data.approved;
    }

    delete data.dateRange;
    delete data.salesDateRange;
    delete data.paymentsDateRange;

    data.status = data.status.join(',')

    data.branch_uuids = data.branch_uuids.join(',');

    return data;
  }

  getFilteredData() {
    let returnData = [];

    const data = this.toJSON();

    for (let attr in data) {
      if (data[attr]) {
        let label = this.attributeLabels[attr];
        let value = _.capitalize(data[attr]);

        let text = `${label}: ${value}`;
        returnData.push({text, attr});
      }
    }

    return returnData;
  }
}

defineTranslatableProperties(SettlementSearch);
